// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.copied-btn[data-v-0394675a] {\n  background-color: green !important;\n  color: white !important;\n  border: 1px solid green !important;\n  transition: background-color .5s;\n}\n.hidden-input[data-v-0394675a] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
